export default __webpack_public_path__ + "static/media/DSC06155.2a33d47a.jpg";